<template>
    <div class="mb-4 text-sm text-white">
        Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
    </div>

    <div v-if="status" class="my-4 font-medium text-sm text-white">
        {{ status }}
    </div>

    <breeze-validation-errors class="my-4" />

    <form @submit.prevent="submit">
        <div class="text-left">
            <breeze-label for="email" value="Email" class="font-bold text-white" />
            <breeze-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
        </div>

        <div class="mt-8">
            <button type="submit"
                class="w-full px-4 py-2 bg-white border border-transparent rounded-md font-bold text-green tracking-widest transition ease-in-out duration-150 hover:bg-green hover:text-white hover:border-white"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
            >
                Send Reset Link
            </button>
        </div>
    </form>
</template>

<script>
    import BreezeButton from '@/Components/Button'
    import BreezeGuestLayout from "@/Layouts/Guest"
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeValidationErrors from '@/Components/ValidationErrors'

    export default {
        layout: BreezeGuestLayout,

        components: {
            BreezeButton,
            BreezeInput,
            BreezeLabel,
            BreezeValidationErrors,
        },

        props: {
            status: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: ''
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.email'))
            }
        }
    }
</script>
